import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderSchedulingBookingsByAppointmentIdConfirm: build.mutation<
      PostV2ProviderSchedulingBookingsByAppointmentIdConfirmApiResponse,
      PostV2ProviderSchedulingBookingsByAppointmentIdConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/bookings/${queryArg.appointmentId}/confirm`,
        method: "POST",
      }),
    }),
    getV2ProviderSchedulingConfirmation: build.query<
      GetV2ProviderSchedulingConfirmationApiResponse,
      GetV2ProviderSchedulingConfirmationApiArg
    >({
      query: () => ({ url: `/v2/provider/scheduling/confirmation` }),
    }),
    putV2ProviderSchedulingConfirmation: build.mutation<
      PutV2ProviderSchedulingConfirmationApiResponse,
      PutV2ProviderSchedulingConfirmationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/confirmation`,
        method: "PUT",
        body: queryArg.setConfirmationRequest,
      }),
    }),
    deleteV2ProviderSchedulingConfirmationByPolicyId: build.mutation<
      DeleteV2ProviderSchedulingConfirmationByPolicyIdApiResponse,
      DeleteV2ProviderSchedulingConfirmationByPolicyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/confirmation/${queryArg.policyId}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderSchedulingBookingsByAppointmentIdConfirmApiResponse =
  /** status 200 OK */ ConfirmBookingResponse;
export type PostV2ProviderSchedulingBookingsByAppointmentIdConfirmApiArg = {
  appointmentId: string;
};
export type GetV2ProviderSchedulingConfirmationApiResponse =
  /** status 200 OK */ ConfirmationConfigListResponse;
export type GetV2ProviderSchedulingConfirmationApiArg = void;
export type PutV2ProviderSchedulingConfirmationApiResponse =
  /** status 200 OK */ ConfirmationConfigResponse;
export type PutV2ProviderSchedulingConfirmationApiArg = {
  setConfirmationRequest: SetConfirmationRequest;
};
export type DeleteV2ProviderSchedulingConfirmationByPolicyIdApiResponse =
  /** status 200 OK */ ConfirmationConfigListResponse;
export type DeleteV2ProviderSchedulingConfirmationByPolicyIdApiArg = {
  policyId: string;
};
export type ConfirmBookingResponse = {
  appointment_id: string;
  confirmation_status?: string | null;
  status: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ConfirmationMode = "auto_lock" | "pending_ack";
export type ConfirmationConfigSchema = {
  /** Null = org-wide; set = per-encounter-type override. */
  encounter_type_id?: string | null;
  mode: ConfirmationMode;
  policy_id: string;
  title?: string | null;
};
export type ConfirmationConfigListResponse = {
  /** The mode that applies when the org has no config (pending_ack). */
  default_mode: string;
  items: ConfirmationConfigSchema[];
  total: number;
};
export type ConfirmationMode2 = "auto_lock" | "pending_ack";
export type ConfirmationConfigSchema2 = {
  /** Null = org-wide; set = per-encounter-type override. */
  encounter_type_id?: string | null;
  mode: ConfirmationMode2;
  policy_id: string;
  title?: string | null;
};
export type ConfirmationConfigResponse = {
  config: ConfirmationConfigSchema2;
};
export type ConfirmationMode3 = "auto_lock" | "pending_ack";
export type SetConfirmationRequest = {
  /** Omit/null for the org-wide mode. */
  encounter_type_id?: string | null;
  mode: ConfirmationMode3;
};
